<template>
  <Modal
    v-model="visible"
    :mask-closable="false"
    title="权益详情"
    :footer-hide="true"
    width="600"
    class="my-modal top p-b"
  >
    <Table :columns="columns" :data="list"></Table>
  </Modal>
</template>

<script>
export default {
  props: ["policyNo", "sourceType"],

  data() {
    return {
      visible: false,
      list: [],
      listIndex: null,
      columns: [
        {
          title: "保障项目",
          key: "rightName",
          align: "center",
        },
        {
          title: "保额/详情",
          key: "rightValue",
          align: "center",
        },
      ],
    };
  },

  methods: {
    async open(listIndex) {
      this.listIndex = listIndex;
      this.getTableData();
    },

    getTableData() {
      // 1.线上产品-2.线下产品
      const url =
        this.sourceType == 1
          ? `/buz/policy/read/detail?policyNo=${this.policyNo}`
          : `/buz/offlinePolicy/mechan/detailEnterPolicy?policyNo=${this.policyNo}`;
      this.$http({
        url,
        type: "GET",
      }).then((res) => {
        if (res.data.rightList && res.data.rightList.length) {
          res.data.insuresList.forEach((item) => {
            const num = item.md5CardNumber;
            res.data.rightList.forEach((item2) => {
              if (num == item2.insuresCardNo) {
                this.list.push(item2);
              }
            });
          });
          this.list = this.list[this.listIndex].rightList;
        }
        this.visible = true;
      });
    },
  },
};
</script>